import { PropsWithChildren } from 'react';

import Debug from '@/components/Debug';
import Card from '@/ui/components/Card';
import DualTime from '@/ui/components/DualTime/DualTime';
import ListCardHeading from '@/ui/components/ListCard/components/ListCardHeading';

import { Props } from './types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const ListCard = ({
  backgroundColorClassName,
  className,
  children,
  debug,
  headingBorder = true,
  headingHref,
  headingActions,
  headingActionsClassName = 'flex items-start space-x-2',
  headingIcon,
  headingIconClassName,
  headingIconTooltip,
  timestamp,
  title,
  subtitle
}: PropsWithChildren<Props>) => {
  return (
    <div>
      <Card backgroundColorClassName={backgroundColorClassName} className={`relative ${className}`}>
        <div className="flex flex-wrap justify-between gap-x-3">
          <ListCardHeading
            headingBorder={headingBorder}
            headingHref={headingHref}
            headingIcon={headingIcon}
            headingIconClassName={headingIconClassName}
            headingIconTooltip={headingIconTooltip}
            subtitle={subtitle}
            title={title}
          />

          {headingActions && <div className={headingActionsClassName}>{headingActions}</div>}
        </div>
        {children}

        {debug && <Debug object={debug} />}
      </Card>

      {timestamp && (
        <div className="text-sm text-gray-600 px-3 -mt-1.5">
          {timestamp.prefix && <span>{timestamp.prefix} </span>}
          <DualTime dateTime={new Date(timestamp.datetime)} memberTZ={timestamp?.time_zone} />
        </div>
      )}
    </div>
  );
};

export default ListCard;
